import React, { PureComponent } from 'react';
import styles from './index.css';
class Poster extends PureComponent {
    render() {
        const { postShow = true, posterUrl = '//p0.ifengimg.com/a/2017/0905/4aaeeaf1c8c482bsize20_w700_h530.jpg', videoType = 'video', } = this.props;
        return (React.createElement("div", { className: videoType === 'miniVideo' ? styles.miniVideo_poster : styles.video_poster, style: { backgroundImage: `url(${posterUrl})`, display: postShow ? 'block' : 'none' } }));
    }
}
export default Poster;
